module.exports = __webpack_public_path__ + "img/logo.295645f6.png";